/**
 * useSitemapStatus Hook
 * 
 * React Query hook for fetching sitemap status data.
 * Migrated from seo-engine-webtools-customer-module
 */

import { useQuery } from '@tanstack/react-query';
import { getSitemapStatus, GetSitemapParams } from '@/services/customer/sitemapApi';
import { SitemapResponse } from '@/types/customer';
import { useSiteStore } from '@/store/site.store';

export interface UseSitemapStatusOptions extends GetSitemapParams {
  siteId?: number;
  enabled?: boolean;
}

export function useSitemapStatus(options: UseSitemapStatusOptions = {}) {
  const selectedSite = useSiteStore((state) => state.selectedSite);
  const siteId = options.siteId ?? selectedSite?.id ?? 1;

  return useQuery<SitemapResponse, Error>({
    queryKey: ['customer-sitemap-status', siteId, options.tool, options.status],
    queryFn: () => getSitemapStatus(siteId, {
      tool: options.tool,
      status: options.status,
    }),
    enabled: options.enabled !== false,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}

export default useSitemapStatus;
